import React from 'react';
import PropTypes from 'prop-types';
import {v4 as uuidv4} from 'uuid';
/* Components */
import Avatar from '../../common/avatar/avatar';
import UserCheckmark from '../../common/user-checkmark/user-checkmark';
/* Helpers */
import {getSortedTagList} from '../../../helpers/util';
import {replaceBRWithNewLine} from '../../../helpers/text';
import {getWidgetListWithNoDuplicatesAndSorted} from '../../../helpers/dashboard-helpers';
/* Styles */
import './dashboard-and-widget-info.scss';

class DashboardAndWidgetInfo extends React.PureComponent {
  preventDragHandler = (e) => {
    e.preventDefault();
  };

  render() {
    return (
      <div className="glu-info-sidebar glu-content glu-content--has-footer">
        <div className="glu-content__header glu-flex-row">
          {!this.props.isWidget && this.props.image ? <Avatar imageSrc={this.props.image} /> : null}
          <div className="glu-flex-grow">
            <div className="glu-h2">{this.props.title}</div>
          </div>
          <div className="glu-flex-shrink">
            <button
              aria-label="close"
              type="button"
              className="glu-btn-link glu-btn__icon g-icon g-icon-close"
              onClick={this.props.onClose}
            />
          </div>
        </div>
        <div className="glu-content__body glu-content__separator">
          {this.props.widgetDescriptionImage ? (
            <div className="glu-content__section">
              <div className="glu-image-container">
                <img
                  src={this.props.widgetDescriptionImage}
                  alt="Widget type"
                  className="glu-image-container__image"
                  onDragStart={this.preventDragHandler}
                />
              </div>
            </div>
          ) : null}
          {(this.props.createdBy || this.props.createdOn) && (
            <div className="glu-content__section glu-info-sidebar__widget_description">
              {this.props.createdBy && (
                <UserCheckmark
                  label="Created by: "
                  ownerId={this.props.ownerId}
                  userLabel={this.props.createdBy}
                />
              )}
              {this.props.createdOn && <p>Created on: {this.props.createdOn}</p>}
              {this.props.createdIn && <p>Created in: {this.props.createdIn}</p>}
            </div>
          )}
          <div className="glu-content__section">
            <div className="glu-h3">Tags</div>
          </div>
          <div className="glu-content__section glu-info-sidebar__widget_description">
            {this.props.tags && this.props.tags.length > 0 ? (
              <div className="tags-row">
                {getSortedTagList(this.props.tags).map((tag) => (
                  <div
                    key={tag.id}
                    style={{backgroundColor: tag.bgColor ? tag.bgColor : ''}}
                    className="glu-pill"
                  >
                    {tag.title}
                  </div>
                ))}
              </div>
            ) : (
              '-'
            )}
          </div>
          <div className="glu-content__section">
            <div className="glu-h3">
              {`${this.props.isWidget ? 'Widget' : 'Dashboard'} description`}
            </div>
          </div>
          <pre className="glu-content-pre glu-content__section glu-info-sidebar__widget_description">
            {this.props.description ? replaceBRWithNewLine(this.props.description) : '-'}
          </pre>
          {this.props.widgetTitleList && this.props.widgetTitleList.length > 0 && (
            <>
              <div className="glu-content__section">
                <div className="glu-h3">Widget list</div>
              </div>
              <div className="glu-content__section glu-info-sidebar__widgets-list">
                {getWidgetListWithNoDuplicatesAndSorted(this.props.widgetTitleList).map(
                  (widgetName) => {
                    return (
                      <div className="glu-h4" key={uuidv4()}>
                        {widgetName}
                      </div>
                    );
                  }
                )}
              </div>
            </>
          )}
        </div>
        {!this.props.enteredFromViewInfo && (
          <div className="glu-content__footer glu-content__separator">
            <div className="glu-flex-grow text-right">
              {!this.props.gridView && (
                <button className="glu-btn glu-btn--primary" onClick={this.props.onActionCb}>
                  {this.props.isWidget ? 'Add Widget' : 'Preview Dashboard'}
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

DashboardAndWidgetInfo.propTypes = {
  children: PropTypes.node,
  ownerId: PropTypes.string,
  createdBy: PropTypes.string,
  createdOn: PropTypes.string,
  createdIn: PropTypes.string,
  description: PropTypes.string,
  isWidget: PropTypes.bool,
  onActionCb: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  tags: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  widgetTitleList: PropTypes.arrayOf(PropTypes.string),
  image: PropTypes.string,
  gridView: PropTypes.bool,
  enteredFromViewInfo: PropTypes.bool,
  widgetDescriptionImage: PropTypes.string,
};

DashboardAndWidgetInfo.defaultProps = {
  children: null,
  ownerId: '',
  createdBy: '',
  createdOn: '',
  createdIn: '',
  description: '',
  isWidget: false,
  tags: null,
  widgetTitleList: [],
  image: '',
  gridView: false,
  onActionCb: null,
  enteredFromViewInfo: false,
  widgetDescriptionImage: '',
};

export default DashboardAndWidgetInfo;
